import { z } from 'zod';
import { CAL_TAG_COLORS } from '../../events/cal-tag-colors.js';
import { calTagNameSchema } from './cal-tag-name-schema.js';
export const createCalTagInputSchema = z.object({
    name: calTagNameSchema,
    color: z.enum(CAL_TAG_COLORS).optional().nullable(),
    confirmNearMatch: z.boolean().optional().default(false),
});
//# sourceMappingURL=create-cal-tag-input.js.map